// Devlopment

// export const SERVER_URL = "http://192.168.1.9";
// export const SERVER_PATH = `${SERVER_URL}/ecom/controllers/api/`;

// export const SERVER_URL = "https://vebbox.in/chakaraartscraft_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "https://vebbox.in/n999_be";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "http://localhost/newbackend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

export const SERVER_URL = "https://janusfoodproducts.com/jaanu_backend";
export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "https://vebbox.in/jaanu_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;